/**
 * Double Dropdown
 * ======================================
 * - toggle hidden attribute on selected dropdown
 * - support multiple widgets
 */

const WIDGET = '.js-DoubleDropdown'
const ATTRIBUTE_NAME = 'data-type'
const ACTIVECLASS = 'current'

class DoubleDropdown {
  constructor() {
    this.elements = document.querySelectorAll(WIDGET)

    this.elements.forEach((widget) => {
      const navButtons = widget.querySelectorAll('.js-DoubleDropdown__type > li > *')
      const navSelect = widget.querySelector('.js-DoubleDropdown__typeSelect')
      const targetSelect = widget.querySelectorAll('.js-DoubleDropdown__targetSelect select')

      navButtons.forEach((button) => {
        button.addEventListener('click', this.clickHandler)
      })

      targetSelect.forEach((select) => {
        select.addEventListener('change', this.selectTargetHandler)
      })

      navSelect.addEventListener('change', this.selectHandler)
    })
  }

  selectTargetHandler = (e) => {
    const select = e.currentTarget
    const option = select.selectedOptions[0]

    select.selectedIndex = 0

    window.location.href = option.getAttribute('data-href')
  }

  selectHandler = (e) => {
    const select = e.currentTarget
    const widget = select.closest(WIDGET)
    const option = select.selectedOptions[0]

    this.switchSelect(widget, option.getAttribute(ATTRIBUTE_NAME))
    this.enableSelect(widget)
  }

  switchSelect = (widget, value) => {
    const targets = widget.querySelectorAll('.js-DoubleDropdown__targetSelect')

    targets.forEach((target) => {
      if(target.getAttribute(ATTRIBUTE_NAME) == value){
        target.removeAttribute('hidden')
      } else {
        target.setAttribute('hidden', 'hidden')
      }
    })
  }

  enableSelect = (widget) => {
    const select = widget.querySelector('.js-DoubleDropdown__targetSelect[disabled]')

    if(select) {
      select.removeAttribute('disabled')

      select.classList.add('glow')

      setTimeout(() => {
        select.classList.remove('glow')
      }, 300);
    }
  }

  clickHandler = (e) => {
    const button = e.currentTarget
    const widget = button.closest(WIDGET)
    const label = widget.querySelector('.dropdown__label span')

    label.innerHTML = button.innerHTML;

    this.switchDropdown(widget, button.getAttribute(ATTRIBUTE_NAME))
    this.enableDropdown(widget)
    this.closeDropdown(widget)

    button.classList.add(ACTIVECLASS)
  }

  closeDropdown = (widget) => {
    widget.classList.add('disable')

    setTimeout(() => {
      widget.classList.remove('disable')
    }, 200);
  }

  enableDropdown = (widget) => {
    const button = widget.querySelector('.js-DoubleDropdown__target-button')

    if(button) {
      button.removeAttribute('disabled')

      button.classList.add('glow')

      setTimeout(() => {
        button.classList.remove('glow')
      }, 300);
    }
  }

  switchDropdown = (widget, value) => {
    const targets = widget.querySelectorAll('.js-DoubleDropdown__target')

    targets.forEach((target) => {
      if(target.getAttribute(ATTRIBUTE_NAME) == value){
        target.removeAttribute('hidden')
      } else {
        target.setAttribute('hidden', 'hidden')
      }
    })
  }
}

new DoubleDropdown()
